import { RegisterDialogComponent } from './index/register-dialog/register-dialog.component';
import { VideosDialogComponent } from './index/videos-dialog/videos-dialog.component';
import { WelcomeDialogComponent } from './index/welcome-dialog/welcome-dialog.component';
import { SharedModule } from './../shared/shared.module';
import { AuthComponent } from './auth.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { IndexComponent } from './index/index.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { LoginComponent } from './login/login.component';
import { onlyNumberDirective } from '../shared/directive/number-only.directive';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { RegisterComponent } from './register/register.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { IndexFooterComponent } from './index/index-footer/index-footer.component';
import { IndexServicesComponent } from './index/index-services/index-services.component';
import { IndexServiceCardComponent } from './index/index-service-card/index-service-card.component';
import { ReferralComponent } from './referral/referral.component';
import { ArticleComponent } from './index/article/article.component';
import { IndexHeaderComponent } from './index/index-header/index-header.component';
import { ArticleHeaderComponent } from './index/article/article-header/article-header.component';
import { StoreDialogComponent } from './index/index-footer/store-dialog/store-dialog.component';
import { IndexServiceDialogComponent } from './index/index-service-dialog/index-service-dialog.component';
import { ContactFormComponent } from './index/contact-form/contact-form.component';
import { DeleteUserComponent } from './delete-user/delete-user.component';
import { TruncatePipe } from '../core/pipes';
import { HeroComponent } from './index/components/hero/hero.component';
import { AiSectionComponent } from './index/components/ai-section/ai-section.component';
import { CertificationsComponent } from './index/components/certifications/certifications.component';
import { ConsultingComponent } from './index/components/consulting/consulting.component';
import { FeaturesComponent } from './index/components/features/features.component';
import { IndustriesComponent } from './index/components/industries/industries.component';
import { OfferComponent } from './index/components/offer/offer.component';
import { StatisticsComponent } from './index/components/statistics/statistics.component';
import { TestimonialsComponent } from './index/components/testimonials/testimonials.component';
import { MotionComponent } from '../shared/motion/motion.component';
import { MotionBackgroundComponent } from './index/components/shared/motion-background.component';
import { SubscriptionPricesLoginComponent } from './subscription-prices-login/subscription-prices-login.component';
import { SubscriptionConfirmComponent } from './subscription-prices-login/subscription-confirm/subscription-confirm.component';
import { SubscriptionQuoteDialogComponent } from './subscription-prices-login/SubscriptionQuoteDialog.component';
import { ScreenToolbarComponent } from '../standalone/ui-components/toolbars/screen-toolbar/screen-toolbar.component';
import { VideoComponent } from './index/video/components/video/video.component';
// Angular Material Imports
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    IndexComponent,
    ForgetPasswordComponent,
    AuthComponent,
    ResetPasswordComponent,
    EmailVerificationComponent,
    TermsConditionsComponent,
    PrivacyPolicyComponent,
    ContactUsComponent,
    WelcomeDialogComponent,
    VideosDialogComponent,
    LoginComponent,
    RegisterDialogComponent,
    RegisterComponent,
    EmailVerificationComponent,
    IndexFooterComponent,
    IndexServicesComponent,
    IndexServiceCardComponent,
    ReferralComponent,
    ArticleComponent,
    IndexHeaderComponent,
    ArticleHeaderComponent,
    StoreDialogComponent,
    IndexServiceDialogComponent,
    ContactFormComponent,
    DeleteUserComponent,
    SubscriptionPricesLoginComponent,
    SubscriptionConfirmComponent
  ], exports: [StoreDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    AuthRoutingModule,
    NgxCaptchaModule,
    TruncatePipe,
    HeroComponent,
    StatisticsComponent,
    TestimonialsComponent,
    OfferComponent,
    FeaturesComponent,
    AiSectionComponent,
    IndustriesComponent,
    CertificationsComponent,
    ConsultingComponent,
    MotionComponent,
    MotionBackgroundComponent,
    SubscriptionQuoteDialogComponent,
    ScreenToolbarComponent,
    VideoComponent,
    // Angular Material Modules
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [onlyNumberDirective]
})
export class AuthModule { }
